import { Avatar, Box, Stack, Typography, SxProps, IconButton } from "@mui/material";
import moment from "moment";
import React from "react";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useTranslation } from "react-i18next";

interface ActivityCommentProps {
  author?: string;
  isReply?: boolean;
  type?: "conversation" | "default";
  date?: Date;
  children: React.ReactNode;
  sx?: SxProps;
  id?: number;
  deleted?: boolean;
  onClickDelete?: () => void;
}
export const ActivityComment: React.FC<ActivityCommentProps> = (props) => {
  const { t } = useTranslation();
  const {
    author,
    isReply,
    date,
    children,
    type = "default",
    sx = {},
    id,
    onClickDelete,
    deleted,
    ...otherProps
  } = props;

  return (
    <Box
      {...otherProps}
      sx={{
        p: "12px 16px",
        bgcolor: isReply ? "primary.alpha" : "backgroundAlpha.main",
        borderRadius: type === "conversation" ? "12px" : "6px",
        ...(type === "conversation" && {
          borderBottomLeftRadius: isReply ? "12px" : 0,
          borderBottomRightRadius: isReply ? 0 : "12px",
        }),
        marginLeft: isReply ? "24px !important" : 0,
        ...sx,
      }}
    >
      {author && (
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Stack direction="row" spacing={1} alignItems="center" pr={5}>
            <Avatar
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "backgroundAlpha.main",
                color: "text.secondary",
                fontSize: 12,
              }}
            >
              {author.slice(0, 1)}
            </Avatar>
            <Typography component="span" fontWeight={500} color="text.primary">
              {author}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography color="text.tier">{moment(date)?.fromNow() || ""}</Typography>
            {isReply && !deleted && onClickDelete && (
              <IconButton
                onClick={onClickDelete}
                sx={{ alignSelf: "flex-end", width: "18px", height: "18px" }}
                color="secondary"
              >
                <DeleteOutlinedIcon sx={{ width: "18px", height: "18px" }} />
              </IconButton>
            )}
          </Stack>
        </Stack>
      )}
      {deleted ? (
        <Typography sx={{ fontStyle: "italic" }}>{t("component:activityComment.body.messageRemoved")}</Typography>
      ) : (
        <Typography>{children}</Typography>
      )}
    </Box>
  );
};

export default ActivityComment;
